import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Box, SectionHelper } from '@wix/design-system';
import { AppContextProvider } from '../../../../AppLoader';
import { ThemedText } from '../../../../ThemedComponents';
import { DeviceRadioList } from '../../../WixAppEnforcement/DeviceRadioList';

/**
 * Body of the redesigned AsAddOn "Select device" step.
 */
export const AsAddOnSelectDeviceBody: React.FC = observer(() => {
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { ownerAppStore: store },
      },
    },
  } = useContext(AppContextProvider);
  const { t } = useTranslation();
  return (
    <Box direction="vertical" width="100%" gap="24px">
      <SectionHelper appearance="success" size="small" fullWidth>
        {t('ownerAppAsAddOnMethod.sectionHelper')}
      </SectionHelper>
      <Box direction="vertical" width="100%" gap={2}>
        <ThemedText>
          {t('ownerAppAsAddOnMethod.selectDeviceStep.choose.label')}
        </ThemedText>
        {store.devices.length === 1 ? (
          <ThemedText weight="bold">{store.devices[0].name}</ThemedText>
        ) : (
          <DeviceRadioList />
        )}
      </Box>
    </Box>
  );
});
